export const MEDIA_CENTER_QUERY_KEYS = {
  likes: 'mediacenter-file-likes',
  comments: 'mediacenter-file-comments',
  folder: 'mediacenter-folder',
  file: 'mediacenter-file',
};

export const MEDIA_CENTER_RAILS_TYPE = 'MediaCenter::File';

export const FOLDER_NOT_FOUND = 'NOT_FOUND';
